import React, { useState, useEffect } from 'react';
import Home from "../components/Home";
import PromotionalBanner from '../components/PromotionalBanner';
import apiService from '../services/apiService';

const Homepage = () => {
  const [speakers, setSpeakers] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomePageData = async () => {
      try {
        setLoading(true);
        
        // Make parallel requests for better performance
        const [speakersResponse, eventsResponse] = await Promise.all([
          apiService.content.getSpeakers(),
          apiService.content.getEvents()
        ]);
        
        setSpeakers(speakersResponse.data);
        setEvents(eventsResponse.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching homepage data:', error);
        setError('Failed to load content. Please try again later.');
        setLoading(false);
      }
    };

    fetchHomePageData();
  }, []);

  return (
    <>
      <PromotionalBanner />
      <Home />
    </>
  );
}

export default Homepage;
